import EmberRouter from '@ember/routing/router';
import config from 'linced-enrolments/config/environment';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  this.route('apply', {
    path: 'apply/:country_code/:school_code',
  });
  this.route('apply-complete', {
    path: 'apply/:country_code/:school_code/complete',
  });
  this.route('school-not-found');

  // Default Route - Do not put routes beneath this one
  this.route('not-found', { path: '/*path' });
});
